import {ReactNode} from "react";
import {Warning} from "@material-ui/icons";
import * as React from "react";
import './styles.css';

export const WarningMessage = (props: { children: ReactNode }) =>
  <div className="WarningMessage">
    <Warning/>
    {props.children}
  </div>
